/**
 * A new 24-hex-character id in MongoDB ObjectId format, for items created in the browser before saving
 * (e.g. a new judging category). The server keeps it if it is unused, otherwise assigns its own.
 */
export const newObjectId = () => {
    const bytes = new Uint8Array(12);
    crypto.getRandomValues(bytes);
    return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
}
